/** Runtime configuration. Nothing secret: this ships to the browser. */

/**
 * PROTOTYPE MODE.
 *
 * MOD-01 runs against `@insightai/mock-api` rather than a backend, because the
 * BB-FR-001→028 endpoints do not exist in the FastAPI service yet. With it on,
 * two things change and nothing else does:
 *
 *   1. `BriefsGateway` resolves to the mock implementation over `mock_data/`
 *   2. the auth guard loads a fixture profile instead of starting a PKCE
 *      redirect to a Keycloak that is not running locally
 *
 * SEC-FR-001 IS NOT RELAXED. There is no token in the fixture at all; the auth
 * store still holds its access token in memory only, still never touches web
 * storage, and the ESLint ban on `localStorage`/`sessionStorage` still applies.
 * What is skipped is the round-trip to an absent identity provider, not the
 * storage rule the AC probes for.
 *
 * DEFAULTS ARE ASYMMETRIC, deliberately:
 *   · dev  → ON unless `VITE_MOCK_API=false`, so `pnpm dev` gives a working
 *            prototype with no setup
 *   · prod → OFF unless `VITE_MOCK_API=true`, so a production build cannot ship
 *            fixture data by forgetting a flag
 * A symmetric default would make the safe case the one you have to remember.
 */
const mockApiFlag = import.meta.env.VITE_MOCK_API
export const isPrototypeMode = import.meta.env.DEV ? mockApiFlag !== 'false' : mockApiFlag === 'true'

export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  marketingUrl: import.meta.env.VITE_MARKETING_URL ?? 'http://localhost:5174',
  prototypeMode: isPrototypeMode,
  keycloak: {
    authorizationEndpoint:
      import.meta.env.VITE_KEYCLOAK_AUTH_URL ??
      'http://localhost:8080/realms/insightai/protocol/openid-connect/auth',
    clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'insightai-console',
    redirectUri: `${window.location.origin}/auth/callback`,
  },
} as const
